module.exports = __webpack_public_path__ + "static/media/bkg_1.9f056c7d.jpg";